import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
});
// Habilita en Prod
// Desabilita el inspecionador de elementos
/*document.addEventListener(
  "keydown",
  function(event) {
    if (event.keyCode == 123) {
      event.preventDefault();
      return false;
    } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
      event.preventDefault();
      return false;
    } else if (event.ctrlKey && event.keyCode == 85) {
      event.preventDefault();
      return false;
    }
  },
  false
);

if (document.addEventListener) {
  document.addEventListener(
    "contextmenu",
    function(e) {
      e.preventDefault();
    },
    false
  );
}*/
